module.exports = __webpack_public_path__ + "img/flip-vertically.506a5884.svg";